module.exports = __webpack_public_path__ + "static/media/Volcanion_gaussian2.81a268df.png";